import { useEffect } from "react";

const BASE_TITLE = "LEMCE | Premium Comfort Essentials";
const SITE_URL = "https://lemce.com";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight client-side SEO: title + description + canonical + Open Graph + JSON-LD.
// Dedupes against any server-prerendered JSON-LD so crawlers/humans never see two blocks.
export default function Seo({ title, description, image, jsonld, canonical }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | LEMCE` : BASE_TITLE;
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title || "LEMCE — Comfort That Stays With You");
    upsertMeta("property", "og:description", description);
    if (image) upsertMeta("property", "og:image", image);
    const canon = canonical || `${SITE_URL}${window.location.pathname}`;
    upsertCanonical(canon);
    upsertMeta("property", "og:url", canon);

    let ld;
    if (jsonld) {
      // remove any prerendered/previous JSON-LD first to avoid duplicates
      document.head.querySelectorAll('script[data-seo-jsonld]').forEach((n) => n.remove());
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.setAttribute("data-seo-jsonld", "1");
      ld.textContent = JSON.stringify(jsonld);
      document.head.appendChild(ld);
    }
    return () => {
      document.title = BASE_TITLE;
      if (ld && ld.parentNode) ld.parentNode.removeChild(ld);
    };
  }, [title, description, image, jsonld, canonical]);
  return null;
}
